import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let FontsComp;

class Fonts extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: FontsComp }; 
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/base-components/fonts-comp" */
      "../../../components/javascript/base-components/fonts-comp").then(function(res) {
        FontsComp = res.FontsComp;
      })
    );

    
;
  }
}

export { Fonts };
